module.exports = __webpack_public_path__ + "img/full0-min.40cf75be.png";